export const enum tableTypes {
  REPORTING = "reporting",
  DETAIL = "detail",
  SUBDETAIL = "subdetail",
}

export const strMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]
